/**
 * Central API base used by every fetch in the app.
 *
 * Build-time configuration:
 *   - .env.development → REACT_APP_API_URL=http://localhost:8765/api
 *   - .env.production  → REACT_APP_API_URL=https://api.ofi-cia.com/api
 *
 * If REACT_APP_API_URL isn't set, falls back to https://api.ofi-cia.com/api so
 * accidental prod builds without the env file don't end up pointing at a
 * developer's machine.
 *
 * `/api` is appended automatically if the env value forgot it, so deploys
 * can't silently break with /login → 404.
 */
const RAW = (process.env.REACT_APP_API_URL || "https://api.ofi-cia.com/api").replace(/\/+$/, "");

export const API_BASE = /\/api$/.test(RAW) ? RAW : RAW + "/api";

/** Same host without `/api` — used to build /storage/... image URLs. */
export const API_HOST = API_BASE.replace(/\/api$/, "");

/** Convenience for storage URLs like getStorageUrl("members/photos/foo.jpg").
 *  Routes through the API /media/{path} endpoint so direct storage access
 *  on the server is not required (avoids symlink / permission issues).
 */
export const getStorageUrl = (path) => {
  if (!path) return null;
  if (/^(https?:|blob:|data:)/.test(path)) return path;
  const clean = path.replace(/^\/?(storage\/)?/, "");
  return `${API_BASE}/media/${clean}`;
};

export default API_BASE;
